import { atom } from "recoil";

const activeMenuPath = atom({
   key: 'pose/active/menu/path',
   default: '/main',
});

export { activeMenuPath }